export default {
    /**
     * @static
     * @type {number}
     * @default 1664
     */
    STAGE_WIDTH: 1664,

    /**
     * @static
     * @type {number}
     * @default 768
     */
    STAGE_HEIGHT: 768,

    /**
     * @static
     * @type {object}
     */
    config: {},

    /**
     * @static
     * @type {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
     */
    renderer: null,

    /**
     * @static
     * @type {PIXI.Container}
     */
    stage: null,

    /**
     * @static
     * @type {P3.Ticker}
     */
    ticker: null,

    /**
     * @static
     * @type {PIXI.Container}
     */
    transitions: null,

    audio: null,

    currentHelpStage: "mixing_1",

    selectedRecipe: null,

    selectedRecipeBuild: null,
    
    selectedCharacter: null,

    doughColour: null,

    doughIngredient: null,

    cutCookieTextures: null,

    finishedRecipe: null,

    randomSelection:  function(array){
        return array[Math.floor(Math.random() * array.length)];
    },

    deg2rad: function (deg) {
        return deg * (Math.PI / 180);
    },

    shuffle: function (array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    },

    getRandomInt: function (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}